<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <CommFilterBar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></CommFilterBar>
      <div class="comm-panel">
        <div class="comm-panel__extra">
          <el-button type="primary" plain size="small" :disabled="!multipleSelection.length" @click="openTerminalRuleDialog">绑定扣费套餐</el-button>
          <el-button type="primary" plain size="small" :disabled="!multipleSelection.length" @click="openBatchVoipBind">批量绑定VOIP组</el-button>
          <el-button type="primary" plain size="small" @click="openVoipSignatureImport">VoIP设备签名</el-button>
          <span class="comm-panel__hint">导出设备名称、设备号后填写 VoIP 设备签名，再导入系统</span>
        </div>
        <div class="tbl-scroll-host">
          <el-table
            ref="table"
            class="comm-table"
            empty-text="暂无数据"
            :data="users"
            v-loading="listLoading"
            highlight-current-row
            size="small"
            height="100%"
            @selection-change="handleSelectionChange"
            @row-click="handleRowClick"
            style="width: 100%"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="KqTerminalId" label="终端标识" width=""></el-table-column>
            <el-table-column prop="TerminalName" label="终端名称" width=""></el-table-column>
            <el-table-column prop="TouchTypeDirection" label="VoIP设备签名" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="DepartmentName" label="所属部门" width=""></el-table-column>
            <el-table-column label="形态" width="88" align="center">
              <template slot-scope="scope">
                <el-tag size="small" :type="phoneKindTagType(scope.row)">{{ phoneKindLabel(scope.row) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="VOIP组" min-width="140" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button
                  v-if="pickVoipGroupId(scope.row)"
                  type="text"
                  class="voip-group-link"
                  @click.stop="openVoipGroupAuth(scope.row)"
                >{{ pickVoipGroupName(scope.row) }}</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="微信注册" width="90" align="center">
              <template slot-scope="scope">
                <el-tag v-if="isSelfPhoneRow(scope.row)" size="small" :type="isWxRegistered(scope.row) ? 'success' : 'info'">
                  {{ isWxRegistered(scope.row) ? '已注册' : '未注册' }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="InstallAddress" label="安装位置" width="" show-overflow-tooltip></el-table-column>
            <el-table-column prop="TerminalDesc" label="备注" width=""></el-table-column>
            <el-table-column label="绑定套餐" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" class="rule-count-link" @click.stop="openTerminalRuleDialogForRow(scope.row)">
                  {{ ruleBindCount(scope.row) }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="">
              <template slot-scope="scope" >
                <el-tag size="small" :type="Number(scope.row.IsOnLine) === 1 ? 'success' : 'info'">
                  {{ Number(scope.row.IsOnLine) === 1 ? '在线' : '离线' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="添加时间" width="180"></el-table-column>
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="total"
          />
        </div>
      </div>

      <!-- VoIP 设备签名：选择文件 -->
      <el-dialog :visible.sync="voipSignatureImportVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onVoipSignatureImportClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-phone-outline"></i></span>
          <div>
            <strong>VoIP设备签名</strong>
            <p>先导出设备表，填写 VoIP设备签名后上传，核对无误再确认写入</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>导出设备表</strong><em>包含设备名称与设备号</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>填写并上传</strong><em>填写 VoIP设备签名</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="exportVoipSignatureFile">
            <span class="pi-template-card__icon"><i class="el-icon-download"></i></span>
            <span class="pi-template-card__meta">
              <strong>导出当前学校 VoIP 设备表.xlsx</strong>
              <em>设备名称、设备号和 VoIP设备签名三列；填写签名后直接回传</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>导出设备表</span>
          </button>
          <el-upload :key="'voip-signature-upload-' + voipSignatureImportKey" class="pi-upload" drag action="#"
            :auto-upload="false" :limit="1" :show-file-list="false" accept=".xlsx,.xls"
            :on-change="onVoipSignatureFileChange" :on-exceed="onVoipSignatureFileExceed">
            <div v-if="voipSignatureFile" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div><strong>{{ voipSignatureFile.name }}</strong><em>已选择，点击「解析并预览」进入核对</em></div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="voipSignatureImportVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!voipSignatureFile"
            :loading="voipSignatureImporting" @click="parseAndImportVoipSignatures">解析并预览</el-button>
        </div>
      </el-dialog>

      <!-- VoIP 设备签名导入核对 -->
      <el-dialog :visible.sync="voipSignaturePreviewVisible" :close-on-click-modal="false" width="720px"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { backToVoipSignatureImport(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>VoIP设备签名导入核对</strong>
            <p>共 {{ voipSignatureRows.length }} 条，确认无误后写入当前学校</p>
          </div>
        </div>
        <el-table :data="voipSignatureRows" class="pi-preview-table" border stripe style="width: 100%" max-height="440">
          <el-table-column type="index" label="#" width="50" align="center" />
          <el-table-column prop="DeviceName" label="设备名称" min-width="150" show-overflow-tooltip />
          <el-table-column prop="DeviceNo" label="设备号" min-width="150" show-overflow-tooltip />
          <el-table-column prop="VoipSignature" label="VoIP设备签名" min-width="180" show-overflow-tooltip />
        </el-table>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToVoipSignatureImport">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :loading="voipSignatureImporting"
            :disabled="!voipSignatureRows.length" @click="saveVoipSignatures">确认导入</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑终端信息"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        destroy-on-close
      >
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="editForm.KqTerminalId" auto-complete="off" :disabled="isSelfPhoneRow(editForm)"></el-input>
            <div v-if="isSelfPhoneRow(editForm)" class="tb-phone-tip">自研话机标识请从班牌终端修改</div>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
          <el-form-item label="所属机构" v-if="editForm.Id">
            <el-input v-model="editForm.DepartmentName" disabled></el-input>
          </el-form-item>

          <el-form-item label="所属天波">
            <el-switch
              v-model="editForm.IsTbPhone"
              :disabled="isSelfPhoneRow(editForm)"
              active-text="天波视频话机"
              inactive-text="仅本平台话机" />
            <div v-if="isSelfPhoneRow(editForm)" class="tb-phone-tip">自研话机由班牌开通，形态固定为自研，不可改为天波/普通</div>
            <div v-else-if="editForm.IsTbPhone" class="tb-phone-tip">开启且学校已同步天波时，保存后将注册为天波「视频话机」</div>
            <div v-else-if="editOrigIsTbPhone" class="tb-phone-tip tb-phone-warn">
              切换为仅本平台话机后，本平台将清除天波设备关联，并不再接收天波在线状态推送。若天波侧仍需解绑，请先在「天波平台」删除该设备；日后若要重新接入，可再次开启「天波视频话机」并保存以重新注册同步。
            </div>
          </el-form-item>

          <el-form-item v-if="isSelfPhoneRow(editForm)" label="VoIP签名">
            <el-input
              v-model.trim="editForm.TouchTypeDirection"
              maxlength="255"
              clearable
              placeholder="请输入 VoIP 设备唯一签名" />
            <div class="tb-phone-tip">用于设备端调用 OpenAPI 获取 VoIP 签名；同一签名不可重复绑定。</div>
          </el-form-item>

          <el-form-item v-if="isSelfPhoneRow(editForm)" label="VOIP组">
            <el-select v-model="editForm.VoipGroupId" clearable filterable placeholder="可选，仅自研" style="width: 100%" :loading="voipGroupLoading">
              <el-option v-for="g in voipGroupOptions" :key="g.id" :label="g.label" :value="g.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-else label="VOIP组">
            <span class="tb-phone-tip">普通话机/天波不可加入微信 VOIP</span>
          </el-form-item>

          <el-form-item label="安装位置">
            <el-input v-model="editForm.InstallAddress" placeholder="如：教学楼 A 座 3 层走廊" clearable></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="新增终端信息"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
        destroy-on-close
      >
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <el-form-item label="终端标识" prop="KqTerminalId">
            <el-input v-model="addForm.KqTerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="终端名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>

          <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->

          <el-form-item label="所属天波">
            <el-switch
              v-model="addForm.IsTbPhone"
              active-text="天波视频话机"
              inactive-text="普通话机" />
            <div v-if="addForm.IsTbPhone" class="tb-phone-tip">开启且学校已同步天波时，保存后将注册为天波「视频话机」</div>
            <div v-else class="tb-phone-tip">本页仅可新增普通话机/天波；自研请从班牌「开通话机」</div>
          </el-form-item>

          <el-form-item label="安装位置">
            <el-input v-model="addForm.InstallAddress" placeholder="如：教学楼 A 座 3 层走廊" clearable></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="绑定扣费套餐"
        :visible.sync="terminalRuleDialog.visible"
        width="640px"
        :close-on-click-modal="false"
        destroy-on-close
        custom-class="terminal-rule-dialog"
        @closed="onTerminalRuleDialogClosed">
        <el-alert
          type="info"
          :closable="false"
          show-icon
          class="terminal-rule-alert"
          :title="terminalRuleDialog.batchMode ? `将覆盖所选 ${terminalRuleDialog.terminalIds.length} 台话机当前套餐绑定；保存为空表示全部清除限制。` : '仅影响当前话机：下列规则才参与选额与扣费；顺序为后台保存顺序。话机侧在「规则优先级」一致时仍按配额到期时间优先。保存全部移除表示不限制规则。'" />

        <div class="terminal-rule-toolbar">
          <div v-if="terminalRuleDialog.batchMode" class="terminal-rule-meta terminal-rule-meta--batch">
            <span class="terminal-rule-meta__label">已选话机</span>
            <span class="terminal-rule-meta__name">{{ terminalRuleDialog.terminalIds.length }} 台</span>
            <span class="terminal-rule-meta__id">批量覆盖绑定</span>
          </div>
          <div v-else-if="terminalRuleDialog.terminalName" class="terminal-rule-meta">
            <span class="terminal-rule-meta__label">终端</span>
            <span class="terminal-rule-meta__name">{{ terminalRuleDialog.terminalName }}</span>
            <span class="terminal-rule-meta__id">{{ terminalRuleDialog.kqTerminalId }}</span>
          </div>
          <div class="terminal-rule-add">
            <el-select
              v-model="addRuleSelect"
              class="terminal-rule-add__select"
              placeholder="选择要添加的套餐规则"
              filterable
              clearable
              :loading="terminalRuleDialog.optionsLoading">
              <el-option
                v-for="opt in ruleOptionListFiltered"
                :key="opt.id"
                :label="opt.label"
                :value="opt.id"
                :disabled="opt.disabled" />
            </el-select>
            <el-button type="primary" :disabled="!addRuleSelect" @click="addTerminalRuleRow">添加</el-button>
          </div>
        </div>

        <el-table
          :data="terminalRuleDialog.orderedRows"
          size="small"
          border
          max-height="300"
          empty-text="暂无绑定，请从上方选择套餐后添加"
          class="terminal-rule-table">
          <el-table-column label="顺序" width="64" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="ruleName" label="套餐规则" min-width="200" show-overflow-tooltip />
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="table-op-pair">
                <el-button type="text" class="table-op-link" size="small" :disabled="scope.$index === 0" @click="moveTerminalRuleUp(scope.$index)">上移</el-button>
                <el-button
                  type="text"
                  class="table-op-link"
                  size="small"
                  :disabled="scope.$index === terminalRuleDialog.orderedRows.length - 1"
                  @click="moveTerminalRuleDown(scope.$index)">下移</el-button>
                <el-button type="text" class="table-op-link table-op-link--danger" size="small" @click="removeTerminalRuleRow(scope.$index)">移除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="terminalRuleDialog.visible = false">取消</el-button>
          <el-button type="primary" :loading="terminalRuleDialog.saveLoading" @click="submitTerminalRules">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量绑定 VOIP 组"
        :visible.sync="batchVoipBind.visible"
        width="560px"
        :close-on-click-modal="false"
      >
        <el-alert type="info" :closable="false" show-icon style="margin-bottom: 14px"
          title="仅自研话机可加入微信 VOIP；普通话机、天波将跳过。已在其他组的自研设备将改绑到所选组。" />
        <div class="tb-phone-tip" style="margin-bottom: 12px;">
          已选 {{ batchVoipBind.eligible.length + batchVoipBind.skipped.length }} 台，可绑定
          <b>{{ batchVoipBind.eligible.length }}</b> 台自研
          <span v-if="batchVoipBindSkippedText">；跳过：{{ batchVoipBindSkippedText }}</span>
        </div>
        <div v-if="batchVoipBindReboundText" class="tb-phone-tip tb-phone-warn" style="margin-bottom: 12px;">
          将改绑：{{ batchVoipBindReboundText }}
        </div>
        <el-form label-width="90px">
          <el-form-item label="目标分组" required>
            <el-select
              v-model="batchVoipBind.voipGroupId"
              filterable
              placeholder="请选择 VOIP 通信组"
              style="width: 100%"
              :loading="voipGroupLoading"
            >
              <el-option v-for="g in voipGroupOptions" :key="g.id" :label="g.label" :value="g.id" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="batchVoipBind.visible = false">取消</el-button>
          <el-button type="primary" :loading="batchVoipBind.saving" :disabled="!batchVoipBind.eligible.length" @click="submitBatchVoipBind">确认绑定</el-button>
        </div>
      </el-dialog>

      <voip-group-auth-dialog
        :visible.sync="voipAuthDialog.visible"
        :voip-group-id="voipAuthDialog.groupId"
        :group-name="voipAuthDialog.groupName"
      />
    </section>
  </section>
</template>

<script>
import util from '../../../util/date'
import { getKqtDeviceTerminalListPage, removeKqtDeviceTerminal, editKqtDeviceTerminal, addKqtDeviceTerminal, getCommPhoneTerminalRuleByTerminalId, saveCommPhoneTerminalRule, saveCommPhoneTerminalRuleBatch, importVoipSignatures } from '../../api/modules/attendance';
import { syucUser } from '../../api/modules/consumption';
import { getCommRuleOptions, getCommVoipEnabledGroups, bindCommVoipDevices } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter'
import { read, utils, writeFile } from 'xlsx'
import './styles/comm-page.css'
import '../../style/person-import-dialog.css'
import CommFilterBar from './components/CommFilterBar.vue'
import DepartmentPane from '../../components/DepartmentPane'
import { normalizeDeptId } from '../../utils/deptCascaderProps'
import VoipGroupAuthDialog from './components/VoipGroupAuthDialog.vue'

/** 话机终端：KqtDeviceTerminal.TerminalTypeId = 7 */
const phoneTerminalTypeId = '7'

export default {
  components: { CommFilterBar, DepartmentPane, VoipGroupAuthDialog },
  data() {
    return {
      filters: {},
      searchList: [
        { label: '终端', key: 'name', width: '160px', placeholder: '终端名称' },
        { label: '序列号', key: 'kqTerminalId', width: '180px', placeholder: '终端标识/序列号' }
      ],
      users: [],
      total: 0,
      buttonList: [],
      page: 1,
      listLoading: false,
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        KqTerminalId: [{ required: true, message: '请输入终端标识', trigger: 'blur' }],
        TerminalName: [{ required: true, message: '请输入终端名称', trigger: 'blur' }]
      },
      editForm: {
        Id: 0,
        KqTerminalId: '',
        TerminalName: '',
        InstallAddress: '',
        TerminalDesc: '',
        DepartmentId: 0,
        DepartmentName: '',
        IsTbPhone: false,
        TerminalTypeId: phoneTerminalTypeId
      },
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        KqTerminalId: [{ required: true, message: '请输入终端标识', trigger: 'blur' }],
        TerminalName: [{ required: true, message: '请输入终端名称', trigger: 'blur' }]
      },
      addForm: {
        KqTerminalId: '',
        TerminalName: '',
        InstallAddress: '',
        TerminalDesc: '',
        DepartmentId: 0,
        IsTbPhone: false,
        TerminalTypeId: phoneTerminalTypeId
      },
      DepartmentId: 0,
      multipleSelection: [],
      /** 编辑打开时是否为天波话机，用于切换提示。最后修改：2026-06-27 */
      editOrigIsTbPhone: false,
      /** 话机终端可扣费套餐绑定弹窗。创建于 2026-05-13 */
      terminalRuleDialog: {
        visible: false,
        terminalId: null,
        terminalIds: [],
        batchMode: false,
        terminalName: '',
        kqTerminalId: '',
        orderedRows: [],
        optionsLoading: false,
        saveLoading: false
      },
      addRuleSelect: null,
      ruleOptionList: [],
      voipGroupOptions: [],
      voipGroupLoading: false,
      voipSignatureImportVisible: false,
      voipSignaturePreviewVisible: false,
      voipSignatureImporting: false,
      voipSignatureFile: null,
      voipSignatureRows: [],
      voipSignatureImportKey: 0,
      voipAuthDialog: {
        visible: false,
        groupId: 0,
        groupName: ''
      },
      batchVoipBind: {
        visible: false,
        saving: false,
        voipGroupId: null,
        eligible: [],
        skipped: []
      }
    }
  },
  computed: {
    /** 下拉中排除已加入列表的规则 */
    ruleOptionListFiltered() {
      const picked = new Set(this.terminalRuleDialog.orderedRows.map((r) => r.ruleId))
      return this.ruleOptionList.map((o) => ({
        ...o,
        disabled: picked.has(o.id)
      }))
    },
    batchVoipBindSkippedText() {
      return (this.batchVoipBind.skipped || [])
        .map((r) => `${r.TerminalName || r.terminalName || r.KqTerminalId || ''}（${this.phoneKindLabel(r)}）`)
        .filter(Boolean)
        .join('、')
    },
    batchVoipBindReboundText() {
      return (this.batchVoipBind.eligible || [])
        .filter((r) => this.pickVoipGroupId(r))
        .map((r) => {
          const name = r.TerminalName || r.terminalName || r.KqTerminalId || ''
          const group = this.pickVoipGroupName(r)
          return group && group !== '-' ? `${name}（${group}）` : name
        })
        .filter(Boolean)
        .join('、')
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    /** 导出当前学校话机的设备名称、设备号和 VoIP 签名。创建于 2026-08-19 */
    async exportVoipSignatureFile() {
      try {
        const res = await getKqtDeviceTerminalListPage({
          page: 1,
          intPageSize: 9999,
          departmentId: this.DepartmentId,
          type: phoneTerminalTypeId
        })
        const source = res.data && res.data.response ? res.data.response.data || [] : []
        const voipDevices = source.filter((row) => {
          const cplateTerminalId = row.CplateTerminalId != null ? row.CplateTerminalId : row.cplateTerminalId
          return cplateTerminalId != null && Number(cplateTerminalId) > 0
        })
        const rows = voipDevices.map((row) => ({
          '设备名称': row.TerminalName || row.terminalName || '',
          '设备号': row.KqTerminalId || row.kqTerminalId || '',
          'VoIP设备签名': row.TouchTypeDirection || row.touchTypeDirection || ''
        }))
        if (!rows.length) {
          this.$message.warning('当前学校没有可导出的 VoIP 设备')
          return
        }
        const sheet = utils.json_to_sheet(rows)
        const book = utils.book_new()
        utils.book_append_sheet(book, sheet, 'VoIP设备')
        writeFile(book, 'VoIP设备签名导入表.xlsx')
      } catch (error) {
        this.$message.error('导出设备失败')
      }
    },
    openVoipSignatureImport() {
      this.voipSignatureFile = null
      this.voipSignatureRows = []
      this.voipSignatureImportKey += 1
      this.voipSignatureImportVisible = true
      this.voipSignaturePreviewVisible = false
    },
    onVoipSignatureImportClosed() {
      if (!this.voipSignaturePreviewVisible) {
        this.voipSignatureFile = null
        this.voipSignatureRows = []
      }
    },
    backToVoipSignatureImport() {
      this.voipSignaturePreviewVisible = false
      this.voipSignatureImportVisible = true
    },
    onVoipSignatureFileChange(file) {
      this.voipSignatureFile = file && file.raw ? file.raw : null
    },
    onVoipSignatureFileExceed(files) {
      const nextFile = files && files[0]
      if (!nextFile) return
      this.voipSignatureImportKey += 1
      this.$nextTick(() => { this.voipSignatureFile = nextFile })
    },
    /** 解析 VoIP 签名文件并进入核对。创建于 2026-08-19 */
    parseAndImportVoipSignatures() {
      if (!this.voipSignatureFile) return
      const file = this.voipSignatureFile
      if (!/\.(xls|xlsx)$/.test(String(file.name || '').toLowerCase())) {
        this.$message.error('请上传 xls 或 xlsx 文件')
        return
      }
      this.voipSignatureImporting = true
      const reader = new FileReader()
      reader.onload = (event) => {
        try {
          const workbook = read(event.target.result, { type: 'binary' })
          const sheet = workbook.Sheets[workbook.SheetNames[0]]
          const source = utils.sheet_to_json(sheet)
          const rows = source.map((item) => ({
            DeviceName: String(item['设备名称'] || item['TerminalName'] || '').trim(),
            DeviceNo: String(item['设备号'] || item['终端标识'] || item['KqTerminalId'] || '').trim(),
            VoipSignature: String(item['VoIP设备签名'] || item['VoipSignature'] || item['TouchTypeDirection'] || '').trim()
          })).filter((item) => item.DeviceNo || item.VoipSignature)
          if (!rows.length) throw new Error('未解析到有效数据')
          if (rows.some((item) => !item.DeviceNo || !item.VoipSignature)) throw new Error('设备号和 VoIP设备签名不能为空')
          this.voipSignatureRows = rows
          this.voipSignatureImportVisible = false
          this.voipSignaturePreviewVisible = true
        } catch (error) {
          this.$message.error(error.message || '文件读取失败')
        } finally {
          this.voipSignatureImporting = false
        }
      }
      reader.onerror = () => {
        this.voipSignatureImporting = false
        this.$message.error('文件读取失败')
      }
      reader.readAsBinaryString(file)
    },
    /** 确认导入 VoIP 签名。创建于 2026-08-19 */
    async saveVoipSignatures() {
      if (!this.voipSignatureRows.length) return
      this.voipSignatureImporting = true
      try {
        const res = await importVoipSignatures({ DepartmentId: this.DepartmentId, Rows: this.voipSignatureRows })
        if (!res.data.success) throw new Error(res.data.msg || '导入失败')
        this.$message.success(res.data.msg || '导入成功')
        this.voipSignaturePreviewVisible = false
        this.voipSignatureRows = []
        this.handleQuery()
      } catch (error) {
        this.$message.error(error.message || '导入失败')
      } finally {
        this.voipSignatureImporting = false
      }
    },
    /** 是否天波视频话机（SubsidyMode=1 或接口 IsTbPhone）。最后修改：2026-06-27 */
    isTbPhoneRow(row) {
      if (!row) return false
      if (row.IsTbPhone === true || row.isTbPhone === true) return true
      const sm = row.SubsidyMode != null ? row.SubsidyMode : row.subsidyMode
      return String(sm) === '1'
    },
    /** 自研话机：有 CplateTerminalId */
    isSelfPhoneRow(row) {
      if (!row || this.isTbPhoneRow(row)) return false
      const cid = row.CplateTerminalId != null ? row.CplateTerminalId : row.cplateTerminalId
      return cid != null && Number(cid) > 0
    },
    phoneKindLabel(row) {
      if (this.isTbPhoneRow(row)) return '天波'
      if (this.isSelfPhoneRow(row)) return '自研'
      return '普通'
    },
    phoneKindTagType(row) {
      if (this.isTbPhoneRow(row)) return 'warning'
      if (this.isSelfPhoneRow(row)) return 'success'
      return 'info'
    },
    isWxRegistered(row) {
      return !!(row && (row.WxDeviceRegistered === true || row.wxDeviceRegistered === true))
    },
    async loadVoipGroupOptions() {
      if (!this.DepartmentId) {
        this.voipGroupOptions = []
        return
      }
      this.voipGroupLoading = true
      try {
        const res = await getCommVoipEnabledGroups({ departmentId: this.DepartmentId })
        if (res.data.success) {
          const list = res.data.response || []
          this.voipGroupOptions = list.map((x) => ({
            id: x.Id != null ? x.Id : x.id,
            label: x.GroupName || x.groupName || ''
          }))
        } else {
          this.voipGroupOptions = []
        }
      } finally {
        this.voipGroupLoading = false
      }
    },
    /**
     * 点击数据行任意列时切换该行勾选（与仅点复选框一致）
     * 避免在复选框上重复 toggle
     */
    handleRowClick(row, column, event) {
      if (column && column.type === 'selection') {
        return
      }
      if (event && event.target && typeof event.target.closest === 'function') {
        if (event.target.closest('.el-checkbox')) {
          return
        }
        if (event.target.closest('.rule-count-link')) {
          return
        }
        if (event.target.closest('.voip-group-link')) {
          return
        }
      }
      this.$refs.table.toggleRowSelection(row)
    },
    onTerminalRuleDialogClosed() {
      this.addRuleSelect = null
      this.ruleOptionList = []
      this.terminalRuleDialog.orderedRows = []
      this.terminalRuleDialog.terminalIds = []
      this.terminalRuleDialog.terminalId = null
      this.terminalRuleDialog.batchMode = false
    },
    /** 列表展示：已绑定的可扣费套餐规则条数（兼容 PascalCase / camelCase）。最后修改：2026-05-13 */
    ruleBindCount(row) {
      const n =
        row.phoneDeductionRuleCount != null
          ? row.phoneDeductionRuleCount
          : row.PhoneDeductionRuleCount != null
            ? row.PhoneDeductionRuleCount
            : 0
      return Number(n) || 0
    },
    /** 从列表数字点击进入绑定弹窗 */
    openTerminalRuleDialogForRow(row) {
      this.openTerminalRuleDialogWithRow(row)
    },
    pickVoipGroupId(row) {
      if (!row) return 0
      const id = row.VoipGroupId != null ? row.VoipGroupId : row.voipGroupId
      return Number(id) || 0
    },
    pickVoipGroupName(row) {
      if (!row) return '-'
      return row.VoipGroupName || row.voipGroupName || '-'
    },
    /** 从话机所属 VOIP 组查看已订阅家长。最后更新：2026-08-27 */
    openVoipGroupAuth(row) {
      const gid = this.pickVoipGroupId(row)
      if (!gid) return
      this.voipAuthDialog.groupId = gid
      this.voipAuthDialog.groupName = this.pickVoipGroupName(row)
      this.voipAuthDialog.visible = true
    },
    /** 话机终端批量绑定 VOIP 组，仅自研可入组。最后更新：2026-08-27 */
    openBatchVoipBind() {
      const rows = this.multipleSelection || []
      if (!rows.length) {
        this.$message.warning('请至少选中一台话机终端')
        return
      }
      const eligible = rows.filter((r) => this.isSelfPhoneRow(r))
      const skipped = rows.filter((r) => !this.isSelfPhoneRow(r))
      if (!eligible.length) {
        this.$message.warning('仅自研话机可加入微信 VOIP 组，所选设备均为普通/天波')
        return
      }
      this.batchVoipBind.eligible = eligible
      this.batchVoipBind.skipped = skipped
      this.batchVoipBind.voipGroupId = null
      this.batchVoipBind.visible = true
      this.loadVoipGroupOptions()
    },
    async submitBatchVoipBind() {
      const gid = Number(this.batchVoipBind.voipGroupId || 0)
      if (!gid) {
        this.$message.warning('请选择目标 VOIP 组')
        return
      }
      const ids = this.batchVoipBind.eligible
        .map((r) => (r.Id != null ? r.Id : r.id))
        .filter((id) => Number(id) > 0)
      if (!ids.length) {
        this.$message.warning('没有可绑定的自研话机')
        return
      }
      this.batchVoipBind.saving = true
      try {
        const res = await bindCommVoipDevices({
          voipGroupId: gid,
          kqtDeviceTerminalIds: ids,
          allowRebind: true
        })
        if (res.data.success) {
          this.$message.success(res.data.msg || '绑定成功')
          this.batchVoipBind.visible = false
          this.handleQuery()
        } else {
          this.$message.error(res.data.msg || '绑定失败')
        }
      } finally {
        this.batchVoipBind.saving = false
      }
    },
    /** 打开终端扣费套餐绑定弹窗，支持单选和多选。最后修改：2026-08-19 */
    async openTerminalRuleDialog() {
      const rows = this.multipleSelection
      if (!rows.length) {
        this.$message.warning('请至少选中一台话机终端')
        return
      }
      if (rows.length > 1) {
        await this.openTerminalRuleBatchDialog(rows)
        return
      }
      await this.openTerminalRuleDialogWithRow(rows[0])
    },
    /** 打开批量绑定套餐弹窗，批量模式默认不读取各终端现有规则。 */
    async openTerminalRuleBatchDialog(rows) {
      const terminalIds = rows.map((row) => row.Id != null ? row.Id : row.id).filter((id) => id > 0)
      if (terminalIds.length !== rows.length) {
        this.$message.error('存在缺少主键 Id 的话机终端')
        return
      }
      this.terminalRuleDialog = {
        ...this.terminalRuleDialog,
        visible: true,
        terminalId: null,
        terminalIds,
        batchMode: true,
        terminalName: '',
        kqTerminalId: '',
        orderedRows: [],
        optionsLoading: true,
        saveLoading: false
      }
      this.addRuleSelect = null
      try {
        const deptId = normalizeDeptId(this.DepartmentId) || 0
        const optRes = await getCommRuleOptions({ departmentId: deptId })
        if (!optRes.data.success) {
          this.$message.error(optRes.data.msg || '加载套餐列表失败')
          this.terminalRuleDialog.visible = false
          return
        }
        this.ruleOptionList = (optRes.data.response || optRes.data.Response || []).map((x) => {
          const id = x.Id != null ? x.Id : x.id
          const name = x.RuleName != null ? x.RuleName : x.ruleName
          const enabled = x.IsEnabled !== false && x.isEnabled !== false
          return { id, label: `${name || ''}${enabled ? '' : '（已停用）'}`, isEnabled: enabled }
        })
      } catch (e) {
        this.$message.error('加载套餐列表失败')
        this.terminalRuleDialog.visible = false
      } finally {
        this.terminalRuleDialog.optionsLoading = false
      }
    },
    /** 打开单台话机的套餐绑定弹窗。 */
    async openTerminalRuleDialogWithRow(row) {
      const tid = row.Id != null ? row.Id : row.id
      if (!tid) {
        this.$message.error('终端缺少主键 Id')
        return
      }
      this.terminalRuleDialog = {
        ...this.terminalRuleDialog,
        visible: true,
        terminalId: tid,
        terminalIds: [tid],
        batchMode: false,
        terminalName: row.TerminalName || row.terminalName || '',
        kqTerminalId: row.KqTerminalId || row.kqTerminalId || '',
        orderedRows: [],
        optionsLoading: true,
        saveLoading: false
      }
      this.addRuleSelect = null
      try {
        const deptId = normalizeDeptId(this.DepartmentId) || 0
        const [optRes, bindRes] = await Promise.all([
          getCommRuleOptions({ departmentId: deptId }),
          getCommPhoneTerminalRuleByTerminalId({ kqtDeviceTerminalId: tid })
        ])
        if (!optRes.data.success) {
          this.$message.error(optRes.data.msg || '加载套餐列表失败')
          this.terminalRuleDialog.visible = false
          return
        }
        const opts = optRes.data.response || optRes.data.Response || []
        this.ruleOptionList = opts.map((x) => {
          const id = x.Id != null ? x.Id : x.id
          const name = x.RuleName != null ? x.RuleName : x.ruleName
          const enabled = x.IsEnabled !== false && x.isEnabled !== false
          return {
            id,
            label: `${name || ''}${enabled ? '' : '（已停用）'}`,
            isEnabled: enabled
          }
        })
        const bound = bindRes.data.response || bindRes.data.Response || []
        if (!bindRes.data.success) {
          this.$message.error(bindRes.data.msg || '加载终端绑定失败')
          this.terminalRuleDialog.visible = false
          return
        }
        this.terminalRuleDialog.orderedRows = bound.map((b) => ({
          ruleId: b.ruleId != null ? b.ruleId : b.RuleId,
          ruleName: b.ruleName != null ? b.ruleName : b.RuleName
        }))
      } catch (e) {
        this.$message.error('加载套餐或绑定失败')
        this.terminalRuleDialog.visible = false
      } finally {
        this.terminalRuleDialog.optionsLoading = false
      }
    },
    addTerminalRuleRow() {
      const id = this.addRuleSelect
      if (id == null) return
      const opt = this.ruleOptionList.find((o) => o.id === id)
      if (!opt) return
      this.terminalRuleDialog.orderedRows.push({
        ruleId: id,
        ruleName: (opt.label || '').replace(/（已停用）$/, '')
      })
      this.addRuleSelect = null
    },
    moveTerminalRuleUp(index) {
      const arr = this.terminalRuleDialog.orderedRows
      if (index <= 0) return
      const row = arr.splice(index, 1)[0]
      arr.splice(index - 1, 0, row)
    },
    moveTerminalRuleDown(index) {
      const arr = this.terminalRuleDialog.orderedRows
      if (index >= arr.length - 1) return
      const row = arr.splice(index, 1)[0]
      arr.splice(index + 1, 0, row)
    },
    removeTerminalRuleRow(index) {
      this.terminalRuleDialog.orderedRows.splice(index, 1)
    },
    async submitTerminalRules() {
      const tid = this.terminalRuleDialog.terminalId
      const terminalIds = this.terminalRuleDialog.terminalIds || []
      if (this.terminalRuleDialog.batchMode ? !terminalIds.length : !tid) return
      this.terminalRuleDialog.saveLoading = true
      try {
        const payload = {
          ruleIds: this.terminalRuleDialog.orderedRows.map((r) => r.ruleId)
        }
        const res = this.terminalRuleDialog.batchMode
          ? await saveCommPhoneTerminalRuleBatch({
            kqtDeviceTerminalIds: this.terminalRuleDialog.terminalIds,
            ...payload
          })
          : await saveCommPhoneTerminalRule({
            kqtDeviceTerminalId: this.terminalRuleDialog.terminalId,
            ...payload
          })
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功')
          this.terminalRuleDialog.visible = false
          this.handleQuery()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } finally {
        this.terminalRuleDialog.saveLoading = false
      }
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery()
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val
      this.handleQuery()
    },
    handleQuery() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: phoneTerminalTypeId
      }
      this.listLoading = true
      getKqtDeviceTerminalListPage(para)
        .then((res) => {
          this.total = res.data.response.dataCount
          this.users = res.data.response.data
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    handleDel() {
      const rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error'
        })
        return
      }

      const row = rows[0]

      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.listLoading = true
          const para = { id: row.Id }
          removeKqtDeviceTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }

            this.handleQuery()
          })
        })
        .catch(() => {})
    },
    handleEdit() {
      const rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error'
        })
        return
      }

      const row = rows[0]

      this.editFormVisible = true
      this.editOrigIsTbPhone = this.isTbPhoneRow(row)
      const voipGroupId = row.VoipGroupId != null ? row.VoipGroupId : row.voipGroupId
      this.editForm = Object.assign({}, row, {
        TerminalTypeId: phoneTerminalTypeId,
        IsTbPhone: this.isTbPhoneRow(row),
        VoipGroupId: voipGroupId || null
      })
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId
      if (this.isSelfPhoneRow(this.editForm)) {
        this.loadVoipGroupOptions()
      }
    },
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0 || this.DepartmentId === '0') {
        this.$message.warning('请先在左侧选择具体的学校机构！')
        return
      }
      this.addFormVisible = true
      this.addForm = {
        KqTerminalId: '',
        TerminalName: '',
        InstallAddress: '',
        TerminalDesc: '',
        DepartmentId: this.DepartmentId,
        IsTbPhone: false,
        TerminalTypeId: phoneTerminalTypeId
      }
    },
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const wasTb = this.editOrigIsTbPhone
          const willTb = !!this.editForm.IsTbPhone
          const confirmMessage = wasTb && !willTb
            ? '切换为「仅本平台话机」后，本平台将清除天波设备关联，并不再接收天波在线状态推送。若设备仍在天波平台登记，请先在「天波平台」删除该设备；需要重新接入时，可再次开启「天波视频话机」并保存以重新注册同步。确认提交吗？'
            : '确认提交吗？'
          const confirmTitle = wasTb && !willTb ? '取消天波同步' : '提示'

          this.$confirm(confirmMessage, confirmTitle, {
            type: wasTb && !willTb ? 'warning' : 'info',
            confirmButtonText: '确认提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.editLoading = true
            const para = Object.assign({}, this.editForm)
            para.TerminalTypeId = phoneTerminalTypeId
            // 自研话机形态固定，禁止改成天波
            if (this.isSelfPhoneRow(para)) {
              para.IsTbPhone = false
            } else {
              para.IsTbPhone = !!para.IsTbPhone
            }
            if (!para.IsTbPhone && !this.isSelfPhoneRow(para)) {
              para.TouchTypeDirection = ''
              para.SubsidyMode = null
            }
            if (!para.DepartmentId) {
              para.DepartmentId = this.DepartmentId
            }
            if (!this.isSelfPhoneRow(para) || para.IsTbPhone) {
              para.VoipGroupId = null
            } else if (para.VoipGroupId === '' || para.VoipGroupId === undefined) {
              para.VoipGroupId = null
            }
            delete para.DepartmentName

            editKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false
                return
              }
              if (res.data.success) {
                this.editLoading = false
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.$refs['editForm'].resetFields()
                this.editFormVisible = false
                this.handleQuery()
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
                this.editLoading = false
              }
            })
          })
        }
      })
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true
            const para = Object.assign({}, this.addForm)
            para.TerminalTypeId = phoneTerminalTypeId
            para.IsTbPhone = !!para.IsTbPhone
            if (!para.DepartmentId) {
              para.DepartmentId = this.DepartmentId
            }

            addKqtDeviceTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false
                return
              }

              if (res.data.success) {
                this.addLoading = false
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.$refs['addForm'].resetFields()
                this.addFormVisible = false
                this.handleQuery()
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
                this.addLoading = false
              }
            })
          })
        }
      })
    },
    handleSyucUser() {
      const rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备进行下发！',
          type: 'error'
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error'
        })
        return
      }

      const arr = []
      rows.forEach((e) => {
        arr.push(e.KqTerminalId)
      })

      const para = {
        deviceNos: arr,
        way: '0'
      }

      this.$confirm('确认进行下发吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: '下发成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        })
        .catch(() => {})
    },
    handleDelUser() {
      const rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备操作！',
          type: 'error'
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error'
        })
        return
      }

      const arr = []
      rows.forEach((e) => {
        arr.push(e.KqTerminalId)
      })

      const para = {
        deviceNos: arr,
        way: '2'
      }

      this.$confirm('确认进行清空人员吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
        })
        .catch(() => {})
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  }
}
</script>

<style scoped>
.phone-terminal-toolbar-extra {
  margin: 8px 0;
  padding: 0 4px;
}
.phone-terminal-toolbar-extra .hint-text {
  margin-left: 12px;
  color: #909399;
  font-size: 13px;
}
.terminal-rule-alert {
  margin-bottom: 14px;
}
.terminal-rule-toolbar {
  margin-bottom: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.terminal-rule-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin-bottom: 10px;
  line-height: 1.4;
}
.terminal-rule-meta__label {
  font-size: 12px;
  color: #94a3b8;
}
.terminal-rule-meta__name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}
.terminal-rule-meta__id {
  font-size: 12px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}
.terminal-rule-add {
  display: flex;
  align-items: center;
  gap: 8px;
}
.terminal-rule-add__select {
  flex: 1;
  min-width: 0;
}
.terminal-rule-add .el-button {
  flex-shrink: 0;
  min-width: 72px;
}
.terminal-rule-table {
  width: 100%;
}
.rule-count-link {
  padding: 0;
  font-weight: 600;
}
.voip-group-link {
  padding: 0;
}
.tb-phone-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.tb-phone-warn {
  color: #e6a23c;
}
.voip-import-tip {
  margin-bottom: 14px;
  color: #606266;
  line-height: 1.6;
}
.voip-upload-file {
  padding: 18px;
  color: #67c23a;
}
.voip-upload-file i {
  margin-right: 8px;
}
.voip-import-table {
  margin-top: 14px;
}
.custom-tbl >>> .el-table__body tr {
  cursor: pointer;
}
/* 与 HandheldTerminal.vue 一致，可按需取消注释隐藏表头全选 */
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */
</style>
